import React, { Component } from "react";
import { Row, Col, FormGroup, Label, Button } from "reactstrap";
import Alert from "react-s-alert";
import _ from "lodash";

import { api } from "../helpers";

export class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            confirmPassword: "",
            token:
                props.match && props.match.params && props.match.params.token
                    ? props.match.params.token
                    : "",
        };

        this.resetPassword = this.resetPassword.bind(this);
    }

    resetPassword() {
        const trimmedPassword = _.trim(this.state.password);
        const trimmedConfirmPassword = _.trim(this.state.confirmPassword);

        const guidRegex = /\b[a-zA-z0-9]{8}-[a-zA-z0-9]{4}-[a-zA-z0-9]{4}-[a-zA-z0-9]{4}-[a-zA-z0-9]{12}\b/;

        if(!guidRegex.test(this.state.token)){
            Alert.warning("Invalid token");
            return;
        }

        if (trimmedConfirmPassword !== trimmedPassword) {
            Alert.warning("Passwords do not match");
            return;
        }
        
        const errorMessage = "There was an error resetting the password";
        api.post("resetPassword", {
            Password: this.state.password,
            Token: this.state.token
        }).then(response => {
            if (response.data && !response.data.hasErrorMessages) {
                Alert.success("Password Reset");
                this.props.history.push("/login")
            } else {
                if(response.data && response.data.errorMessages 
                    && response.data.errorMessages.length 
                    && response.data.errorMessages.length > 0) {
                   Alert.error(response.data.errorMessages.join("<br />")); 
                }
                else {
                    Alert.error(errorMessage);
                }
            }
        }).catch(error => Alert.error(errorMessage))
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col xs={6} md={3}>
                        <FormGroup>
                            <Label>New Password:</Label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.state.password}
                                onChange={e => this.setState({ password: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={3}>
                        <FormGroup>
                            <Label>Confirm Password:</Label>
                            <input
                                type="password"
                                className="form-control"
                                value={this.state.confirmPassword}
                                onChange={e => this.setState({ confirmPassword: e.target.value })}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="expand-md">
                    <Col xs={6} md={3} className="text-right justify-content-end">
                        <Button
                            className="btn btn-primary"
                            onClick={this.resetPassword}
                        >
                            Submit
                        </Button>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js